import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectMapList, selectTitleSlug } from '@repo/store/maps/slices/mapData';
import { useCallback } from 'react';
import { useMapPinOperations } from '../../game-map/hooks/useMapPinOperations';
import { useMapSwitcher } from '../../map-sidebar/hooks/useMapSwitcher';
export const useMapDescriptionLinkHandler = () => {
  const $ = _c(6);
  const maps = useAppSelector(selectMapList);
  const titleSlug = useAppSelector(selectTitleSlug);
  const currentExternalMapId = useAppSelector(selectExternalMapId);
  const {
    selectMarkerInMap
  } = useMapPinOperations();
  const {
    switchMap
  } = useMapSwitcher();
  let t0;
  if ($[0] !== currentExternalMapId || $[1] !== maps || $[2] !== selectMarkerInMap || $[3] !== switchMap || $[4] !== titleSlug) {
    t0 = href => {
      let url;
      try {
        url = new URL(href);
      } catch {
        return;
      }
      if (url.host !== "maps") {
        return;
      }
      const [, pathMapId] = url.pathname.split("/").filter(Boolean);
      const locationId = url.searchParams.get("location") || "";
      const isExternalId = pathMapId?.match(/^[a-zA-Z0-9]{10}$/);
      const mapExternalId = isExternalId ? pathMapId : maps?.find(map => map.id === pathMapId)?.externalId;
      if (!mapExternalId) {
        return;
      }
      const targetMap = maps?.find(map_0 => map_0.externalId === mapExternalId);
      if (!targetMap || !titleSlug) {
        return;
      }
      if (targetMap.externalId === currentExternalMapId && locationId) {
        selectMarkerInMap(locationId, {
          flyTo: true,
          selectSource: "description_link"
        });
        return;
      }
      switchMap(mapExternalId, {
        focusLocationId: locationId || undefined,
        updatePath: true
      });
    };
    $[0] = currentExternalMapId;
    $[1] = maps;
    $[2] = selectMarkerInMap;
    $[3] = switchMap;
    $[4] = titleSlug;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};